
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5JjoD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $52992e244d1337e7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $52992e244d1337e7$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': 'Todos os sites',
    'navigation.global-shortcuts.apps.align': 'Alinhar',
    'navigation.global-shortcuts.apps.analytics': "Dados de an\xe1lise",
    'navigation.global-shortcuts.apps.assets': 'Recursos',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': 'Hub da empresa',
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.focus': 'Foco',
    'navigation.global-shortcuts.apps.goals': 'Metas',
    'navigation.global-shortcuts.apps.home': "P\xe1gina inicial",
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': 'Projetos',
    'navigation.global-shortcuts.apps.studio': "Est\xfadio",
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': 'Equipes',
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Fechar',
    'navigation.global-shortcuts.menu-expand-item.site-aria-label': 'Site de {name}',
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': "(indispon\xedvel no momento)",
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': "Abrir \xedcone de link externo",
    'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(carregando)',
    'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(carregando)',
    'navigation.global-shortcuts.shortcut-action.open-menu-label': 'Abrir menu',
    'navigation.global-shortcuts.sites': 'Sites de {productName}'
};

});


//# sourceMappingURL=pt_BR.b5da0792.js.map
